import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StorageService } from 'src/app/utils/storage/storage.service'

import { AuthService } from 'src/app/services/auth.service'
import { environment } from 'src/environments/environment'

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

    private token: any

    constructor(
        private route: ActivatedRoute,
        private storageService: StorageService,
        private authService: AuthService
    ) {

    }

    ngOnInit() {
        // var self = this
        // this.route.queryParams.subscribe(params => {
        // 	setTimeout(() => {
        // 		const token = params['token'];
        // 		console.log('token here:', token)
        // 		if (token !== null || token !== '') {
        // 			console.log('Token:', token);
        // 			// Now you have the token, you can use it to communicate with your server
        // 			self.authService.checkTokenApp(token)
        // 		} else {
        // 			// no token, please check if our token from the storage is valid
        // 			console.log('token not found, please redirect?')
        // 			// window.location.href = environment.interop.authCore.linkRedirectAuth
        // 		}
        // 	}, 100)
        // });
    }


}
